import type { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import type { IconPropsT } from './Icon';
import Icon from './Icon';

const DangerousIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill={theme.colors.primary.variant8}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.104 17 3 12.875V7.104L7.104 3h5.792L17 7.104v5.792L12.875 17Zm.625-1.5h4.542l3.229-3.229V7.729L12.25 4.5H7.729L4.5 7.729v4.542Zm.042-2.229L10 11.062l2.229 2.209 1.042-1.042L11.062 10l2.209-2.229-1.042-1.042L10 8.938 7.771 6.729 6.729 7.771 8.938 10l-2.209 2.229ZM10 10Z" />
      </svg>
    </Icon>
  );
};

export default DangerousIcon;
